import { useRecoilState } from 'recoil';

import remove from 'lodash-es/remove';

import { withBookmarkMenus, withMenu } from '@bo-recoil/common/selector';
import menuApi from '@bo-apis/system/menuApi';

export const useBookmarkMenu = (menuNumber) => {
  const [menu, setMenu] = useRecoilState(withMenu(menuNumber));
  const [bookmarkMenus, setBookmarkMenus] = useRecoilState(withBookmarkMenus);

  const addBookmarkMenu = async () => {
    const newBookmarkMenus = [...bookmarkMenus];

    const alreadyBookmark = bookmarkMenus.includes(menuNumber);

    if (newBookmarkMenus.length >= 50) {
      alert('저장 가능한 즐겨찾기 개수(50개)를 초과하였습니다. 즐겨찾기 삭제 후 저장해주세요.');
      return newBookmarkMenus;
    }

    if (!alreadyBookmark) {
      setMenu({ ...menu, isBookmark: true });
      newBookmarkMenus.push(menuNumber);
      setBookmarkMenus(newBookmarkMenus);
      await synchronize(newBookmarkMenus);
    }
  };

  const removeBookmarkMenu = async () => {
    const newBookmarkMenus = [...bookmarkMenus];
    const alreadyBookmark = bookmarkMenus.includes(menuNumber);
    setMenu({ ...menu, isBookmark: false });

    if (alreadyBookmark) {
      remove(newBookmarkMenus, (bookmarkMenuNumber) => bookmarkMenuNumber === menuNumber);
      setBookmarkMenus(newBookmarkMenus);

      await synchronize(newBookmarkMenus);
    }
  };

  const updateBookmarkMenu = async (isBookmark) => {
    if (isBookmark) {
      await addBookmarkMenu();
    } else {
      await removeBookmarkMenu();
    }
  };

  const updateBookmarkMenus = async (newBookmarkMenus) => {
    await synchronize(newBookmarkMenus);
  };

  const synchronize = async (newBookmarks = []) => {
    await menuApi.createBookmarkMenu({
      bookmarkMenuContents: JSON.stringify(newBookmarks),
    });
  };

  return { updateBookmarkMenu, updateBookmarkMenus };
};
